module.exports = __webpack_public_path__ + "img/FrontKingMountainBackground2_w_200.1bbb3693.jpg";